module.exports = __webpack_public_path__ + "img/giftbox@2x.641e79d.webp";